<div class="filter-dropdown">
  <div
    class="filter-dropdown__dropdown vox-dropdown-input"
    ngbDropdown>
    <button
      type="button"
      class="filter-dropdown__dropdown-toggle"
      ngbDropdownToggle>
      {{ "events.company-call-history.filters.options." + this.selectedOption | lowercase | Translate }}
    </button>
    <ul
      class="filter-dropdown__dropdown-menu"
      ngbDropdownMenu>
      <li
        class="filter-dropdown__dropdown-item"
        ngbDropdownItem
        *ngFor="let option of options"
        (click)="selectOption(option)">
        {{ "events.company-call-history.filters.options." + option | lowercase | Translate }}
      </li>
      <li
        class="drodown-filter__dropdown-item drodown-filter__dropdown-item-empty"
        *ngIf="options?.length === 0">
        {{ "events.company-call-history.filters.options.no-options" | Translate }}
      </li>
    </ul>
  </div>
</div>
